import React, { Component } from 'react';
import moment from "moment";

import seal from "../../../assets/印章.png";

class Contract extends Component {
    render() {
        const { data, isSeal } = this.props;
        return (
            <div id="contract">
                <div className="title">服务协议</div>
                <div className="module">
                    <div>
                        甲方 : {data.hotel_name}
                    </div>
                    <div>
                        地址 : {data.billing_addr}
                    </div>
                    <div>
                        联系人 : {data.billing_name}
                    </div>
                    <div>
                        联系电话 : {data.billing_tel}
                    </div>
                </div>

                <div className="module">
                    <div>
                        乙方 : 浙江乾虎科技有限公司（或简称“乾虎科技”）
                    </div>
                    <div>
                        地址 : 浙江省宁波市鄞州区天童南路575号304室
                    </div>
                    <div>
                        联系人 : 韩贝
                    </div>
                    <div>
                        联系电话 : 17682358008
                    </div>
                </div>

                <div className="module">
                    <div>
                        一、您通过 账号:  {data.account}订购乾虎科技提供的如下产品/服务：
                    </div>
                    <div>
                        订单编号 : {data.out_trade_no || ""}
                    </div>
                    <div>
                        订单时间 :  {data.add_time ? moment(data.add_time).format('YYYY年 MM月 DD日') : <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</span>}
                    </div>
                    <div>
                        订单名称 : 千乘财务管理系统（GCH集团定制版）
                    </div>
                    <div>
                        订单金额 : {/[\u4e00-\u9fa5]/.test(data.money) ? data.money : "￥" + (data.money || "9600.00")}
                        {/* (不含税价:￥9056.60,增值税税款合计:￥543.40(增值税：6%),价税合计:￥9600.00) */}
                    </div>
                    <div>
                        购买内容 : 千乘财务管理系统（GCH集团定制版）一年使用权
                    </div>
                    <div>
                        服务有效时间 : {moment(data.current_time || "2019-07-01").format('YYYY-MM-DD')} 至 {moment(data.expire_date).format('YYYY-MM-DD')}
                    </div>
                </div>

                <div className="module">
                    二、您和乾虎科技就上述服务的其它权利义务，应以双方共同确认的服务条款为准（确认形式包括但不限于双方盖章、或您在订购服务时予以线上点击确认）。
                </div>

                <div className="module">
                    三、您应按时付款。您订购的千乘财务管理系统（GCH集团定制版）为预付费服务，在收到您支付的款项之后，乾虎科技才开始为您提供对应时长的服务。
                </div>

                <div className="module">
                    四、乾虎科技保留在您未按照约定支付全部费用之前不向您提供服务和/或技术支持，或者终止服务和/或技术支持的权利。同时，乾虎科技保留对后付费服务中的欠费行为追究法律责任的权利。
                </div>

                <div className="module">
                    <div>五、您应将款项支付至乾虎科技指定的如下账号</div>
                    <div>
                        开户名称：浙江乾虎科技有限公司
                    </div>
                    <div>
                        开户行：中信银行股份有限公司宁波明州支行
                    </div>
                    <div>
                        账号：8114701014600234364
                    </div>
                </div>

                <div className="module">
                    六、发票：支付成功后，您可登陆<a href="#">千乘财务管理系统（GCH集团定制版）</a>，在系统后台申请发票，乾虎科技将向您开具等额发票并邮寄给您。
                </div>

                <div className="footer">
                    <div className="left">
                        <div>甲方 : {data.hotel_name}</div>
                        <div>（盖章处）</div>
                        <div>日期 : {data.add_time ? moment(data.add_time).format('YYYY年 MM月 DD日') : <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</span>}</div>
                    </div>
                    <div className="right">
                        {isSeal && <img src={seal} alt="" />}
                        <div>乙方 : 浙江乾虎科技有限公司</div>
                        <div>（盖章处）</div>
                        <div>日期 : {data.add_time ? moment(data.add_time).format('YYYY年 MM月 DD日') : <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</span>}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contract;


// WEBPACK FOOTER //
// ./src/components/user/ApplicationContract/Contract.js